import {HttpRequest} from "@angular/common/http";

const busyMethods: Set<string> = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const UNBLOCKED_HEADER: string = 'X-Unblocked';

export function blockedHttpMethodFilter(req: HttpRequest<any>): boolean {
  return !busyMethods.has(req.method) || req.headers.has(UNBLOCKED_HEADER);
}
